import { defineMessages } from 'react-intl';

export default defineMessages({
    doYou: {
        id: 'ml.quoteandbind.ho.productSelection.Do you...',
        defaultMessage: 'Do you...'
    },
    rent: {
        id: 'ml.quoteandbind.ho.productSelection.Rent',
        defaultMessage: 'RENT'
    },
    ownAHome: {
        id: 'ml.quoteandbind.ho.productSelection.Own a home',
        defaultMessage: 'OWN A HOME'
    },
    ownACondo: {
        id: 'ml.quoteandbind.ho.productSelection.Own a condo',
        defaultMessage: 'OWN A CONDO'
    },
    landlordOwnAHome: {
        id: 'ml.quoteandbind.ho.productSelection.Landlord Own a home',
        defaultMessage: 'LANDLORD OWN A HOME'
    },
    landlordOwnACondo: {
        id: 'ml.quoteandbind.ho.productSelection.Landlord Own a condo',
        defaultMessage: 'LANDLORD OWN A CONDO'
    },
    seeAdditionalFAQTopics: {
        id: 'ml.quoteandbind.ho.productSelection.See additional FAQ Topics',
        defaultMessage: 'See additional FAQ Topics'
    }
});
